/* eslint-disable max-classes-per-file */

import { LitElement, html } from 'lit';
import classNames from 'classnames';
import '../PostInfo';
import '../MediaViewer';
import '../PostCaption';
import { getMediaType } from '../../../utils';
import { AnalyticsEvents, AnalyticsScores, EmbedTypes } from '../../../consts';
// eslint-disable-next-line
import styles from '!!lit-css-loader!postcss-loader!sass-loader!./MasonryTile.scss';

class MasonryTile extends LitElement {
  static styles = [styles];

  static get properties() {
    return {
      post: { type: Object },
      options: { type: Object },
      index: { type: Number },
      onClick: { type: Function },
      handlePostFocused: { type: Function },
      handleMediaError: { type: Function },
    };
  }

  handleVideoError = (err) => {
    this.handleMediaError(this.post, err);
  };

  render() {
    const { media, caption, profilePic, fullname, username, service, time, customLink, favicon } =
      this.post;
    const { hideCaptionsOnHover, disableHashtagLinks, disableDates, masonryHideCaptions } =
      this.options;
    const date = !disableDates && time;

    if (this.post.media[0]) {
      return html`
        <div
          class=${classNames('masonry-tile masonry-tile--media', {
            'masonry-tile--hide-captions': hideCaptionsOnHover || masonryHideCaptions,
            'masonry-tile--disable-clicking': this.options.disableClicking,
          })}
          @click=${() => this.onClick(this.index)}
          @transitionend=${(evt) => {
            this.handlePostFocused(evt, this.post, this.index);
          }}
        >
          <div class="masonry-tile__media">
            <media-viewer
              class="masonry-tile__media-viewer"
              .media=${media[0]}
              service=${service}
              .onVideoError=${this.handleVideoError}
              muted
              loop
              playing
            ></media-viewer>
          </div>
          <div class=${classNames('masonry-tile__caption', {
            'masonry-tile__caption--hidden': masonryHideCaptions,
          })}>
            <div class="masonry-tile__info">
              <post-info
                profilePic=${profilePic}
                fullname=${fullname}
                .username=${username}
                favicon=${favicon}
                service=${service}
                date=${date}
                ?bottom=${hideCaptionsOnHover || masonryHideCaptions}
                ?overlay=${hideCaptionsOnHover || masonryHideCaptions}
              />
            </div>
            ${
              !masonryHideCaptions
                ? html`<post-caption
                    class="masonry-tile__text"
                    caption=${caption}
                    service=${service}
                    ?disableLinks=${disableHashtagLinks}
                  ></post-caption>`
                : ``
            }
              ${
                customLink?.linkUrl
                  ? html`
                      <a
                        class="masonry-tile__btn"
                        href=${customLink?.linkUrl}
                        @click=${(e) => {
                          e.stopPropagation();
                          giggAnalytics.logEvent(AnalyticsEvents.CTA_CLICK, {
                            boardId: __gigg.accountId,
                            boardType: EmbedTypes.MASONRY,
                            folderId: __gigg.folderId,
                            postIndex: this.index,
                            postId: this.post.id,
                            postType: service,
                            mediaType: getMediaType(media),
                            isCarousel: media?.length > 1,
                            CTA_URL: customLink.linkUrl,
                            scoreWeight: AnalyticsScores.CTA_CLICK,
                            firstEvent: {
                              _id: window.giggFirstEvent?._id,
                              createdDate: window.giggFirstEvent?.createdDate,
                            },
                            inViewEvent: {
                              _id: window.latestViewEvent?._id,
                              createdDate: window.latestViewEvent?.createdDate,
                            },
                          });
                        }}
                        target="_blank"
                      >
                        ${customLink?.linkText}
                      </a>
                    `
                  : ''
              }
            </post-caption>
          </div>
        </div>
      `;
    }
    return html`
      <div class="masonry-tile masonry-tile--text" @click=${() => this.onClick(this.index)}>
        <post-caption
          class="masonry-tile__text"
          caption=${caption}
          service=${service}
          ?disableLinks=${disableHashtagLinks}
        ></post-caption>
        <img class="masonry-tile__favicon" src="${favicon}" alt="Favicon ${username}" />
        <post-info
          class="masonry-tile__info"
          profilePic="${profilePic}"
          fullname=${fullname}
          .username=${username}
          favicon=${favicon}
          service=${service}
          date=${date}
          bottom
        ></post-info>
      </div>
    `;
  }
}

customElements.define('masonry-tile', MasonryTile);
